const prefix = 'coupon-code/'
const Types = {
	SET_ACTUAL_COUPON: prefix + 'SET_ACTUAL_COUPON'
}
const setActualCoupon = coupon => ({
	type: Types.SET_ACTUAL_COUPON,
	payload: { coupon }
})
export const Creators = { setActualCoupon }
const initialState = {
	couponCode: ''
}
export default function reducer(state = initialState, action) {
	switch (action.type) {
		case Types.SET_ACTUAL_COUPON:
			return { ...state, couponCode: action.payload.coupon }
		default:
			return state
	}
}